import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e10ba86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "close-modal" }
const _hoisted_2 = { class: "button-modal-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isActive)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        id: "base-modal-component",
        class: _normalizeClass(["default-modal", { 'dismissing-default-modal': _ctx.showDismissAnimation }])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["card-modal", { 'dismissing-card-modal': _ctx.showDismissAnimation }])
        }, [
          _renderSlot(_ctx.$slots, "header", {}, () => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("span", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleBaseModal(false)))
              }, " Fechar ")
            ])
          ], true),
          _renderSlot(_ctx.$slots, "content", {}, undefined, true),
          _renderSlot(_ctx.$slots, "footer", {}, () => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("button", {
                class: "btn btn-default btn-primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleBaseModal(false)))
              }, " Entendi ")
            ])
          ], true)
        ], 2)
      ], 2))
    : _createCommentVNode("", true)
}